(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ModifierSearch', ModifierSearch);

    ModifierSearch.$inject = ['$resource'];

    function ModifierSearch($resource) {
        var resourceUrl =  'api/_search/modifiers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
